import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=5db4b40c&scoped=true&"
var script = {}
import style0 from "./Media.vue?vue&type=style&index=0&id=5db4b40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4b40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db4b40c')) {
      api.createRecord('5db4b40c', component.options)
    } else {
      api.reload('5db4b40c', component.options)
    }
    module.hot.accept("./Media.vue?vue&type=template&id=5db4b40c&scoped=true&", function () {
      api.rerender('5db4b40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vendor/vue-medialibrary/src/components/svgs/Media.vue"
export default component.exports